import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import {
  capitalizeFirstLettersOfString,
  formatPhoneNumber,
} from "../../../../utils/stringOperations";

const toTitleCase = (str) => {
  if (!str) return '';
  return str.toLowerCase().split(' ').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');
};

const About = ({ legislator }) => {
  if (!legislator) return <div>Loading...</div>

  const currentDate = new Date();
  const endDate = legislator.legislatorDetails.endDate
    ? new Date(legislator.legislatorDetails.endDate)
    : null;

  const isActive = endDate && endDate > currentDate;

  const serviceYears = legislator.legislatorDetails.sessionMemberships
    .map((m) => new Date(m.session.legislature.startDate).getFullYear())
    .sort((a, b) => a - b)
    .join(", ");

  // Construct the dynamic district PDF link
  const chamberPrefix = legislator.legislatorDetails.chamber === "HOUSE" ? "HD" : "SD";
  const rawDistrict = legislator.legislatorDetails.district?.number;
  const districtNumber = String(rawDistrict).trim().padStart(3, "0");
  const districtPdfLink = `https://archive.legmt.gov/content/research/map-districtPDFs/${chamberPrefix}${districtNumber}_DemographicProfile_2025.pdf`;

  return (
    <div id="info">
      <MDBRow className="row-cols-1 row-cols-lg-2 row-cols-xl-3 g-1">
        <MDBCol className="mb-2">
          <h6 className="lead d-flex align-items-start">
            <strong className="label">Party:</strong>
            <span>{legislator?.legislatorDetails?.politicalParty?.name}</span>
          </h6>
        </MDBCol>
        <MDBCol className="mb-2">
          <h6 className="lead d-flex align-items-start">
            <strong className="label">Seat:</strong>
            <span>
              {toTitleCase(legislator?.legislatorDetails?.chamber)} Chamber {legislator?.legislatorDetails?.floorSeatNumber || "--"}
            </span>
          </h6>
        </MDBCol>
        <MDBCol className="mb-2">
          <h6 className="lead d-flex align-items-start">
            <strong className="label">Service:</strong>
            <span>{serviceYears}</span>
          </h6>
        </MDBCol>
        <MDBCol className="mb-2">
          <h6 className="lead d-flex align-items-start">
            <strong className="label">Status:</strong>
            <span>{legislator.legislatorDetails.isActive ? "Active" : "Former"}</span>
          </h6>
        </MDBCol>
        <MDBCol className="mb-2">
          <h6 className="lead d-flex align-items-start">
            <strong className="label">County:</strong>
            <span>{legislator?.legislatorProfile?.county} County</span>
          </h6>
        </MDBCol>
        <MDBCol className="mb-2">
          <h6 className="lead d-flex align-items-start">
            <strong className="label">District:</strong>
            <span>
              <a
                href={districtPdfLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                {capitalizeFirstLettersOfString(
                  legislator?.legislatorDetails?.district?.name
                )}
              </a>
            </span>
          </h6>
        </MDBCol>
        <MDBCol className="mb-2">
          {legislator.legislatorProfile.phoneNumber && (
            <h6 className="lead d-flex align-items-start">
              <strong className="label">Phone:</strong>
              <span>{formatPhoneNumber(legislator?.legislatorProfile?.phoneNumber)}</span>
            </h6>
          )}
        </MDBCol>
        <MDBCol className="mb-2">
          {legislator.legislatorProfile.addressLine && (
            <h6 className="lead d-flex align-items-start">
              <strong className="label">Address:</strong>
              <span>
                {legislator?.legislatorProfile?.addressLine},{" "}
                {legislator?.legislatorProfile?.city},{" "}
                {legislator?.legislatorProfile?.postalCode}
              </span>
            </h6>
          )}
        </MDBCol>
      </MDBRow>
      <hr/>
      <h6 className="lead pt-3"><strong>Lawmakers of Montana (Copper Book) Biography:</strong></h6>
      <p className="mb-3">{legislator?.legislatorProfile?.biography}</p>
      {/* <h5 id="social" className="mb-3">
        future: social buttons
      </h5> */}
    </div>
  );
};

export default About;
